<script>
import { Dashboard } from '@uppy/vue'

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'

export default {
  name: 'FileUpload',
  props: ['for', 'allowMultipleUploads', 'show'],
  components: {
    Dashboard,
  },
  data(){
    return {
      shown: this.show
    }
  },
  watch: {
    show(){
      this.shown = this.show
      if (this.shown) {
        this.$emit('file-upload-opened')
      }
      else {
        this.$emit('file-upload-closed')
      }
    }
  },
  computed: {
    uppy(){
        const uppy = new Uppy({
          allowMultipleUploads: false,
        })
        uppy.use(AwsS3, {
            companionUrl: 'https://xali-uppy-companion.herokuapp.com/'
        })
        uppy.on('upload-success', (file, response) => {
          this.$emit('file-uploaded', response.uploadURL)
          uppy.reset()
        })
        return uppy
    },
    title(){
      return `Upload file for ${this.for}`
    }
  },
  beforeDestroy () {
    this.uppy.close()
  }
}
</script>

<template>

    <b-modal
      v-model="shown"
      size="md"
      :title="title"
      id="upload-files"
      hide-footer
    >
      <dashboard :uppy="uppy"/>
      <template #modal-footer="{}">
      </template>
    </b-modal>
</template>
